class BlockSize extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectElementName = `select[name="options[${this.getAttribute(
      "data-select"
    )}]"]`;
    this.initializeSizeChangeListeners();
  }

  initializeSizeChangeListeners() {
    const sizeButtons = this.querySelectorAll(".block-size__btn");
    sizeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.changeSize(button);
      });
    });
  }

  changeSize(activeButton) {
    const value = activeButton.value;

    // Actualiza el select
    const selectElement = this.getSelectElement();
    if (selectElement) {
      this.updateSelectValueAndDispatchChangeEvent(selectElement, value);
    }

    // Quitar clase activa de todos los botones
    const sizeButtons = this.querySelectorAll(".block-size__btn");
    sizeButtons.forEach((btn) => btn.classList.remove("active"));

    // Añadir clase activa al botón seleccionado
    activeButton.classList.add("active");
  }

  getSelectElement() {
    const selectElement = document.querySelector(this.selectElementName);
    if (!selectElement) {
      throw new Error("Select element not found");
    }
    return selectElement;
  }

  updateSelectValueAndDispatchChangeEvent(selectElement, value) {
    selectElement.value = value;
    const changeEvent = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    selectElement.dispatchEvent(changeEvent);
  }
}

customElements.define("block-size", BlockSize);
